import { useRef } from "react";
import { allStates } from "./states";

export default function StateSel({handleChange, formData}){
    
    const selRef = useRef(null);

    const getLabel = (st) => {
        allStates.states.map((v) => {
            if(st === v.key){
                return v.label
            }
        })
    }

    const GetValues = () => {

        return(
            <>{
                allStates.states.map((v,i) => (
                    <option defaultValue="select" key={v.key} label={v.label} slected={v.label} value={v.key}>
                        {getLabel(v.key)}
                    </option>

            ))}</>
        )
    }

    return(
        <div>
            <select className="form-control form-select"
                value={formData.state}
                id="required-input"
                onChange={(e) => handleChange(e)}
                name="state"
                ref={selRef}
            >
    
                <GetValues />
            </select>
        </div>

    )

}